/* ============================================================
   MAISON52 — cadeaux cumulables selon le montant du panier.
   Paliers (montant des articles après remises, hors cadeaux) :
     150 € → livraison réduite (géré par les profils de livraison)
     210 € → Hand spinner offert  (ajouté automatiquement)
     320 € → Boxer offert EN PLUS (le client choisit sa taille dans le panier)
   Le boxer n'est offert QU'à partir de 320 € (jamais pour un ensemble tracksuit).
   Les cadeaux sont des produits « non listés » à 0 € (cadeau-handspinner,
   cadeau-boxer) : ils se cumulent et s'ajoutent / se retirent tout seuls
   si le panier passe au-dessus / en dessous du palier.
   La jauge (snippet free-shipping-bar) affiche les 3 paliers.
   ============================================================ */
(function () {
  var SPINNER_GIFT = 55057924882771;              // cadeau-handspinner — Offert
  var BOXER_GIFTS = { S: 55057925767507, M: 55057925800275, L: 55057925833043, XL: 55057925865811 };
  var GIFT_PRODUCT_IDS = [10879191679315, 10879192269139];
  var SPINNER_AT = 21000, BOXER_AT = 32000;       // centimes
  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var busy = false, lastCart = null;

  function t(fr, en) { return FR ? fr : en; }
  function isGift(it) { return GIFT_PRODUCT_IDS.indexOf(it.product_id) >= 0; }
  // 1 boxer offert dès 320 € d'articles (hors cadeaux) — jamais pour un ensemble tracksuit
  function boxersAllowed(cart, q) { return q >= BOXER_AT ? 1 : 0; }
  function boxerQty(cart) { return cart.items.reduce(function (n, it) { return n + (boxerIds().indexOf(it.variant_id) >= 0 ? it.quantity : 0); }, 0); }
  function boxerIds() { return Object.keys(BOXER_GIFTS).map(function (k) { return BOXER_GIFTS[k]; }); }
  function money(c) { return (Math.max(0, c) / 100).toLocaleString(FR ? 'fr-FR' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }

  function api(path, body) {
    return fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json(); });
  }

  function banner(msg) {
    var el = document.getElementById('m52GiftBanner');
    if (!el) {
      el = document.createElement('div');
      el.id = 'm52GiftBanner';
      el.style.cssText = 'position:fixed;left:50%;bottom:18px;transform:translateX(-50%);background:#111;color:#fff;padding:13px 18px;border-radius:999px;font-size:13px;z-index:100010;box-shadow:0 10px 28px rgba(0,0,0,.28);max-width:min(92vw,420px);text-align:center;transition:opacity .25s ease;font-family:-apple-system,BlinkMacSystemFont,"Hanken Grotesk",Arial,sans-serif;';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.opacity = '1';
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.style.opacity = '0'; }, 5000);
  }

  function drawerOpen() {
    var d = document.getElementById('CartDrawer');
    if (!d) return false;
    var r = d.getBoundingClientRect();
    return r.width > 0 && r.left < window.innerWidth - 10 && getComputedStyle(d).visibility !== 'hidden';
  }

  function afterChange() {
    if (/\/cart\/?$/.test(location.pathname)) {
      if (!sessionStorage.getItem('m52_gift_reload')) {
        try { sessionStorage.setItem('m52_gift_reload', '1'); } catch (e) {}
        location.reload();
      }
      return;
    }
    if (drawerOpen()) document.dispatchEvent(new CustomEvent('cart:refresh'));
    else api('cart.js').then(function (c) { document.dispatchEvent(new CustomEvent('cart:updated', { detail: c })); });
  }

  // ---------- Choix de la taille du boxer offert ----------
  function pickerHTML() {
    return '<div class="m52-giftpick__t">🎁 ' + t('Boxer offert débloqué — choisis ta taille :', 'Free boxers unlocked — pick your size:') + '</div>' +
      '<div class="m52-giftpick__s">' + Object.keys(BOXER_GIFTS).map(function (s) {
        return '<button type="button" data-m52-boxer="' + s + '">' + s + '</button>';
      }).join('') + '</div>';
  }
  function css() {
    if (document.getElementById('m52GiftCss')) return;
    var st = document.createElement('style');
    st.id = 'm52GiftCss';
    st.textContent = '.m52-giftpick{border:1.5px dashed #111;border-radius:10px;padding:10px 12px;margin:10px 0;font-size:13px;background:#fff;color:#111;text-align:left}' +
      '.m52-giftpick__t{font-weight:600;margin-bottom:8px}.m52-giftpick__s{display:flex;gap:6px;flex-wrap:wrap}' +
      '.m52-giftpick__s button{min-width:44px;height:36px;border:1px solid #111;background:#fff;color:#111;border-radius:6px;font-size:13px;cursor:pointer}' +
      '.m52-giftpick__s button:hover{background:#111;color:#fff}';
    document.head.appendChild(st);
  }
  function placePickers(show) {
    css();
    [].forEach.call(document.querySelectorAll('.m52-giftpick'), function (n) { if (!show) n.remove(); });
    if (!show) return;
    var anchors = [].slice.call(document.querySelectorAll('.fsb--drawer, .fsb--cart'));
    var drawer = document.getElementById('CartDrawerContent');
    if (!anchors.length && drawer) anchors = [drawer.firstElementChild || drawer];
    anchors.forEach(function (a) {
      if (a.nextElementSibling && a.nextElementSibling.classList && a.nextElementSibling.classList.contains('m52-giftpick')) return;
      var el = document.createElement('div');
      el.className = 'm52-giftpick';
      el.innerHTML = pickerHTML();
      a.parentNode.insertBefore(el, a.nextSibling);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-m52-boxer]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    api('cart/add.js', { items: [{ id: BOXER_GIFTS[b.getAttribute('data-m52-boxer')], quantity: 1 }] })
      .then(function () { placePickers(false); banner('🎁 ' + t('Boxer offert ajouté à ton panier', 'Free boxers added to your cart')); afterChange(); });
  });

  // ---------- Synchronisation ----------
  function sync() {
    if (busy) return;
    busy = true;
    api('cart.js').then(function (cart) {
      lastCart = cart;
      var q = 0;
      cart.items.forEach(function (it) { if (!isGift(it)) q += it.final_line_price; });
      var spinnerLine = cart.items.filter(function (it) { return it.variant_id === SPINNER_GIFT; })[0];
      var boxerLines = cart.items.filter(function (it) { return boxerIds().indexOf(it.variant_id) >= 0; });
      var updates = {}, changed = false, add = null;

      if (q >= SPINNER_AT) {
        if (!spinnerLine) add = SPINNER_GIFT;
        else if (spinnerLine.quantity > 1) { updates[spinnerLine.key] = 1; changed = true; }
      } else if (spinnerLine) { updates[spinnerLine.key] = 0; changed = true; }

      var allowed = boxersAllowed(cart, q), have = 0;
      boxerLines.forEach(function (l) {
        var keep = Math.max(0, Math.min(l.quantity, allowed - have));
        if (keep !== l.quantity) { updates[l.key] = keep; changed = true; }
        have += keep;
      });

      placePickers(have < allowed);

      var chain = Promise.resolve();
      if (changed) chain = chain.then(function () { return api('cart/update.js', { updates: updates }); });
      if (add) chain = chain.then(function () {
        return api('cart/add.js', { items: [{ id: add, quantity: 1 }] }).then(function () {
          banner('🎁 ' + t('Hand spinner offert ajouté à ton panier', 'Free hand spinner added to your cart'));
        });
      });
      if (changed || add) chain = chain.then(afterChange);
      else { try { sessionStorage.removeItem('m52_gift_reload'); } catch (e) {} }
      if (q >= BOXER_AT && !boxerLines.length && !sessionStorage.getItem('m52_boxer_note')) {
        try { sessionStorage.setItem('m52_boxer_note', '1'); } catch (e) {}
        banner('🎁 ' + t('Boxer offert débloqué : choisis ta taille dans le panier', 'Free boxers unlocked: pick your size in the cart'));
      }
      if (q < BOXER_AT) { try { sessionStorage.removeItem('m52_boxer_note'); } catch (e) {} }
      return chain;
    }).catch(function () {}).then(function () { busy = false; });
  }

  // le tiroir panier est re-rendu par le thème : on remet le choix de taille si besoin
  function watchDrawer() {
    var d = document.getElementById('CartDrawerContent');
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function () {
      if (!lastCart) return;
      var q = 0;
      lastCart.items.forEach(function (it) { if (!isGift(it)) q += it.final_line_price; });
      if (boxerQty(lastCart) < boxersAllowed(lastCart, q) && !d.querySelector('.m52-giftpick')) placePickers(true);
    }).observe(d, { childList: true });
  }

  // Petites photos des cadeaux sur la frise (jauge free-shipping-bar)
  function fsbImages() {
    if (document.getElementById('m52FsbImg')) return;
    var st = document.createElement('style');
    st.id = 'm52FsbImg';
    st.textContent =
      '.fsb__legend-item[data-fsb-amount="21000"]::before,.fsb__legend-item[data-fsb-amount="32000"]::before{content:"";display:block;width:44px;height:44px;border-radius:8px;background:#f2f2f0 center/84% no-repeat;border:1.5px solid #e3e3e3;margin:0 0 5px auto;opacity:.7;transition:opacity .2s ease,border-color .2s ease}' +
      '.fsb__legend-item[data-fsb-amount="21000"]::before{background-image:url("https://cdn.shopify.com/s/files/1/0914/7862/2547/files/IMG-8217.png?width=132")}' +
      '.fsb__legend-item[data-fsb-amount="32000"]::before{background-image:url("https://cdn.shopify.com/s/files/1/0914/7862/2547/files/IMG-8874.png?width=132")}' +
      '.fsb__legend-item.is-reached::before{opacity:1;border-color:#1f8f55}';
    document.head.appendChild(st);
  }

  function init() { fsbImages(); sync(); watchDrawer(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('cart:updated', function () { setTimeout(sync, 50); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
